import { t } from '@/boot/i18n';

export default function useBaseValidation() {
  function required(v) {
    return (v != null && !!v.toString()) || t('baseValidation.requiredField');
  }

  function requiredImage(image: string) {
    return (v) => image.length > 0 || required(v);
  }

  function requiredArray(v: []) {
    return (!!v && !!v.length) || t('baseValidation.requiredField');
  }

  function requiredObject(v) {
    return (!!v && !!v.id) || t('baseValidation.requiredField');
  }

  function email(v) {
    return /.+@.+\..+/.test(v) || t('baseValidation.incorrectEmail');
  }

  function matchOfPasswords(password, passwordConfirmation) {
    return password === passwordConfirmation || t('baseValidation.passwordsDontMatch');
  }

  function minLength(minStringLength) {
    return (v) => {
      if (v) {
        return v?.length >= minStringLength || `${t('baseValidation.minCharacters.start')} ${minStringLength} ${t('baseValidation.minCharacters.end')}`;
      }
      return true;
    };
  }

  function maxLength(maxStringLength) {
    return (v) => {
      if (v) {
        return v?.length < maxStringLength + 1 || `${t('baseValidation.maxCharacters.start')} ${maxStringLength} ${t('baseValidation.maxCharacters.end')}`;
      }
      return true;
    };
  }

  function min(minNumber) {
    return (v) => v >= minNumber || `${t('baseValidation.minValue')} ${minNumber}`;
  }

  function max(maxNumber) {
    return (v) => v <= maxNumber || `${t('baseValidation.maxValue')} ${maxNumber}`;
  }

  function requiredCustomText(text) {
    return (v) => !!v || text;
  }

  function requiredNumber(number) {
    return Number.isFinite(Number(number)) || t('baseValidation.numberValue');
  }

  return {
    required,
    requiredImage,
    requiredArray,
    requiredObject,
    email,
    matchOfPasswords,
    minLength,
    maxLength,
    min,
    max,
    requiredCustomText,
    requiredNumber,
  };
}
